module.exports = __webpack_public_path__ + "img/feature_buy_zh.f3a014c9.png";